<template>
  <ModalStructure
    :class="$style.contactModal"
    shouldCloseOnBlur
    :showModal="showModal"
    showCloseButton
    @close="$emit('close')"
  >
    <template v-slot:header>
      <HeadingMedium
        data-test-id="ContactModal__title"
      >
        {{ title }}
      </HeadingMedium>
    </template>
    <template v-slot:body>
      <ParagraphBody>
        {{ $options.ContactModalBody }}
      </ParagraphBody>
    </template>
    <template v-slot:footer>
      <div
        :class="$style.contactFooter"
      >
        <ButtonGroup
          isFullWidth
        >
          <Button
            data-test-id="ContactModal__emailBtn"
            hasOutline
            :isFullWidth="false"
            text="Email Us"
            type="secondary"
            @click="$emit('onEmail')"
          />
          <Button
            data-test-id="ContactModal__callBtn"
            hasOutline
            :isFullWidth="false"
            text="Schedule A Call"
            type="secondary"
            @click="$emit('onCall')"
          />
          <Button
            v-if="showChatOption"
            data-test-id="ContactModal__chatBtn"
            hasOutline
            :isFullWidth="false"
            :isLoading="isChatButtonLoading"
            text="Live Chat"
            type="secondary"
            @click="$emit('onChat')"
          />
        </ButtonGroup>
      </div>
    </template>
  </ModalStructure>
</template>

<script>
import {
  Button,
  ButtonGroup,
  HeadingMedium,
  ModalStructure,
  ParagraphBody,
} from '@jumpcloud/ui-components';

import { ContactModalBody } from 'client/util/Constants/FeatureTrialConstants';

export default {
  name: 'ContactModal',

  ContactModalBody,

  components: {
    Button,
    ButtonGroup,
    HeadingMedium,
    ModalStructure,
    ParagraphBody,
  },

  props: {
    isChatButtonLoading: {
      type: Boolean,
    },
    showChatOption: {
      type: Boolean,
    },
    showModal: {
      type: Boolean,
    },
    title: {
      type: String,
      default: () => '',
    },
  },
};
</script>
<style module scoped>
.contactModal {
  --modal-padding: var(--jc-spacer-small);
  --modal-width: 80ch;

  text-align: left;
}

.contactFooter {
  padding: 0;
  width: 100%;
}

.contactFooter > div {
  padding: 0 var(--jc-spacer-medium);
  width: 100%;
}

.contactModal /deep/ div > div {
  padding: var(--jc-spacer-medium);
}

.contactModal /deep/ footer:not(:empty) {
  padding-top: 0;
}
</style>
